import axiosInstance from "./AxiosInstance";

export default {
    get() {
        return axiosInstance({
            method: "get",
            url: "/registrations_rec",
        });
    },
    create(body) {
        return axiosInstance({
            method: "post",
            url: "/registrations_rec",
            data: body,
        });
    },
    update(id, body) {
        return axiosInstance({
            method: "patch",
            url: `/registrations_rec/${id}`,
            data: body,
        });
    },
    delete(id) {
        return axiosInstance({
            method: "delete",
            url: `/registrations_rec/${id}`,
        });
    },
};
